<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="invoiceBooks"
      style="width: 100%"
      row-key="id"
      @sort-change="handleSortChange"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="130"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            store-module="invoiceBook"
            :options="['settings']"
          />
        </template>
        <template
          slot-scope="scope"
        >
          <Actions :invoiceBook="scope.row"/>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import Actions from './Actions';
  import TableSettings from '../../TableSettings';
  import columns, { allColumns, labels } from './columns';

  export default {
    components: {
      Actions,
      TableSettings,
      ...columns,
    },
    data() {
      return {
        labels,
        allColumns,
        tableKey: 0,
        currentPage: 1,
        currentSort: {
          prop: 'name',
          order: 'ascending',
        },
      };
    },
    computed: {
      invoiceBooks() {
        return this.$store.getters['invoiceBook/invoiceBooks'];
      },
      tableConfig() {
        return JSON.parse(JSON.stringify(this.$store.getters['invoiceBook/tableConfig']));
      },
      loading() {
        return this.$store.getters['invoiceBook/loading'];
      },
    },
    watch: {
      tableConfig() {
        this.tableKey++;
      },
    },
    async mounted() {
      this.$store.commit('invoiceBook/setFilterString', '');
      this.$store.commit('invoiceBook/setCurrentPage', this.currentPage);
      this.$store.commit('invoiceBook/setSorting', this.currentSort);
      await this.$store.dispatch('invoiceBook/fetchAll');
    },
    methods: {
      handleCurrentChange(val) {
        this.$store.commit('invoiceBook/setCurrentPage', val);
        this.$store.dispatch('invoiceBook/fetchAll');
      },
      handleSortChange({ column, prop, order }) {
        this.$store.commit('invoiceBook/setSorting', {
          prop,
          order
        });
        this.$store.dispatch('invoiceBook/fetchAll');
      },
    },
  };
</script>

